export default "__VITE_ASSET__Ci2S$pa$__"